import React, { useContext, useEffect, useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/three";
import { useGLTF } from "@react-three/drei";
import CurrentContext from "./CurrentContext";
import useSetMaterialFinish from "./useTextureCustom";
import { handleExportGLTF } from "./utils/jsHelpers";
import { useControls } from "leva";
import { Deg0, Deg90CCW } from "./utils/AnimaonSprings";

export default function Model_camano() {
  const { nodes, materials, scene } = useGLTF("models/camano.glb");
  const [finishes, setFinishes] = useState({});
  const [tileFinishes, setTileFinishes] = useState({});

  const {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    secondDoor,
    colorScheme,
    setcolorScheme,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
    sideBurner,
    refrigerator,
    refrigeratorType,
    setRefrigeratorType,
    animation,
    tileColorScheme,
    setTileColorScheme,
    sink,
    groutColor,
    setGroutColor,
  } = useContext(CurrentContext);

  useEffect(() => {
    if (siding === "Quartzite") {
      if (colorScheme === "Sandstone Tan SR12") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-sandstone-tan.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-sandstone-tan.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
      if (colorScheme === "Misty Gray SR16") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-misty-gray.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
    } else if (siding === "Faux Rock") {
      if (colorScheme === "Gray") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-gray.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
      if (colorScheme === "Brown") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-brown.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
    } else if (siding === "No Siding") {
      setFinishes({
        diffuseMap: "../textures/big/no-siding-1k.jpeg",
        displacementMap: null,
        // normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
        normalScale: [1, 1],
        repeat: [5, 5],
        // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
      });
    }
    {
      if (tileColorScheme === "Chocolate") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-chocolate.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#928272",
        });
      }
      if (tileColorScheme === "Civic Sand") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-civic-sand.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#e5e3dec7",
        });
      }
      if (tileColorScheme === "Notable beige") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-notable-beige.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#eeebe5",
        });
      }
      if (tileColorScheme === "Park Lane Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-park-lane-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#c6ccd4",
        });
      }
      if (tileColorScheme === "Union smoke") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-union-smoke.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#8c95a2",
        });
      }
      if (tileColorScheme === "Iron Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-iron-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#818084",
        });
      }
      if (tileColorScheme === "No Tile") {
        setTileFinishes({
          diffuseMap: "../textures/big/no-siding-1k.jpeg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#818084",
        });
      }
    }
  }, [siding, colorScheme, tileColorScheme]);

  useSetMaterialFinish(materials.siding, finishes, setLoading);

  useSetMaterialFinish(materials.frame, groutColor, setLoading);

  useSetMaterialFinish(materials.island_top, tileFinishes, setLoading);

  const { rotation_Grill } = useSpring({
    rotation_Grill: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 500 : 0,
  });

  const { rotation_Side_burner } = useSpring({
    rotation_Side_burner: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 0 : 500,
  });

  return (
    <group dispose={null}>
      {/* grill-30_agnus */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["grill-30_agnus"].geometry}
        material={materials["grill-30_agnus"]}
        visible={grill === '30" Angus' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agngus_inner_grill"].geometry}
          material={materials["grill-30_agngus_inner_grill"]}
        />
        <animated.group
          position={[0.372, 1.095, 0.025]}
          rotation={rotation_Grill}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agngus_inner_grill_side_frame"].geometry}
            material={materials["grill-30_agngus_inner_grill_side_frame"]}
            // position={[0.372, 1.095, 0.025]}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_clock"].geometry}
              material={materials["grill-30_agnus_clock"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_handle"].geometry}
              material={materials["grill-30_agnus_handle"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top"].geometry}
              material={materials["grill-30_agnus_top"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_frame"].geometry}
              material={materials["grill-30_agnus_top_frame"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_glass"].geometry}
              material={materials["grill-30_agnus_top_glass"]}
            />
          </animated.mesh>
        </animated.group>

        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_logo"].geometry}
          material={materials["grill-30_agnus_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob"].geometry}
          material={materials["grill-30_agnus_stove_knob"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_alpha"].geometry}
          material={materials["grill-30_agnus_stove_knob_alpha"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_logo"].geometry}
          material={materials["grill-30_agnus_stove_knob_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_wire"].geometry}
          material={materials["grill-30_agnus_wire"]}
        />
      </mesh>

      {/* grill-30_bull_griddle */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["grill-30_bull_griddle"].geometry}
        material={materials["grill-30_bull_griddle"]}
        visible={grill === '30" Bull Griddle Head' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_bull_griddle_knoob_logo"].geometry}
          material={materials["grill-30_bull_griddle_knoob_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_bull_griddle_logo"].geometry}
          material={materials["grill-30_bull_griddle_logo"]}
        />
        <animated.group
          position={[0.408, 1.054, -0.097]}
          rotation={rotation_Grill}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_top"].geometry}
            material={materials["grill-30_bull_griddle_top"]}
            // position={[0.408, 1.054, -0.097]}
          />
        </animated.group>
      </mesh>
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes['new-_griddle_head'].geometry}
        visible={grill === '30" Bull Griddle Head' ? true : false}
        material={materials.knob_plane}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['new-_griddle_head_logo'].geometry}
          material={materials.knob_plane}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['new-_griddle_head_logo_frame'].geometry}
          material={materials.knob_plane}
        />
        <animated.group position={[0, 1.082, -0.067]} rotation={rotation_Grill}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['new-_griddle_head_top'].geometry}
            material={materials['handle_001.001']}
            // position={[0, 1.082, -0.067]}
          />
        </animated.group>
      </mesh> */}

      {/* grill-30_lonestar_grill_head */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["grill-30_lonestar_grill_head"].geometry}
        material={materials["grill-30_lonestar_grill_head"]}
        visible={grill === '30" Lonestar' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_alpha"].geometry}
          material={materials["grill-30_lonestar_grill_head_alpha"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_inner_black"].geometry}
          material={materials["grill-30_lonestar_grill_head_inner_black"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_inner_grill"].geometry}
          material={materials["grill-30_lonestar_grill_head_inner_grill"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_frame_knob"].geometry
          }
          material={materials["grill-30_lonestar_grill_head_top_frame_knob"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_frame_knoob_logo"].geometry
          }
          material={
            materials["grill-30_lonestar_grill_head_top_frame_knoob_logo"]
          }
        />

        <animated.group
          position={[0.369, 1.095, 0.021]}
          rotation={rotation_Grill}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_top_frame_side_frame"]
                .geometry
            }
            material={
              materials["grill-30_lonestar_grill_head_top_frame_side_frame"]
            }
            // position={[0.369, 1.095, 0.021]}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_glass"].geometry}
              material={materials["grill-30_lonestar_grill_head_glass"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_handle"].geometry}
              material={materials["grill-30_lonestar_grill_head_handle"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_inner_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_inner_frame"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_top_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_top_frame"]}
            />
          </animated.mesh>
        </animated.group>
      </mesh>

      {/* 38"_brahma */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['38"_brahma'].geometry}
        material={materials['38"_brahma']}
        visible={grill === '38" Brahma' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_brahma_alpha'].geometry}
          material={materials['38"_brahma_alpha']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_brahma_front_part'].geometry}
          material={materials['38"_brahma_front_part']}
        />

        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_brahma_metal'].geometry}
          material={materials['38"_brahma_metal']}
        />

        <animated.group
          position={[0.365, 1.108, 0.03]}
          rotation={rotation_Grill}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes['38"_brahma_glass'].geometry}
            material={materials['38"_brahma_glass']}
            position={[-0.365, -1.108, -0.03]}
          />
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes['38"_brahma_temperature'].geometry}
            material={materials['38"_brahma_temperature']}
            position={[-0.365, -1.108, -0.03]}
          />
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes['38"_brahma_top'].geometry}
            material={materials['38"_brahma_top']}
            // position={[0.365, 1.108, 0.03]}
          />
        </animated.group>
      </mesh>

      {/* 30" Door/Propane Drawer Combo */}
      {door === '30" Door/Propane Drawer Combo' && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["door-door_propane_drawer_combo_1"].geometry}
            material={materials["door-door_propane_drawer_combo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["door-door_propane_drawer_combo_2"].geometry}
            material={materials["Material.005"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.door_propane_drawer_combo_handle.geometry}
            material={materials.trash_drawer_handle}
          />
        </>
      )}

      {/* door-double_door */}
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_door"].geometry}
        material={materials.double_door}
        visible={door === '30" Double Door' ? true : false}
      /> */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.double_door.geometry}
        material={materials.double_door}
        visible={door === '30" Double Door' ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.double_door_1.geometry}
        material={materials["Material.004"]}
        visible={door === '30" Double Door' ? true : false}
      />

      {/* 30" Door/Drawer Combo */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_drawer_door_combo_1"].geometry}
        material={materials["door-double_drawer_door_combo"]}
        visible={door === '30" Door/Drawer Combo' ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_drawer_door_combo_2"].geometry}
        material={materials["Material.003"]}
        visible={door === '30" Door/Drawer Combo' ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.double_drawer_door_combo_handle.geometry}
        material={materials.double_drawer_door_combo_handle}
        visible={door === '30" Door/Drawer Combo' ? true : false}
      />
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_drawer_door_combo"].geometry}
        material={materials["door-double_drawer_door_combo"]}
        visible={door === '30" Door/Drawer Combo' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.double_drawer_door_combo_handle.geometry}
          material={materials.double_drawer_door_combo_handle}
        />
      </mesh> */}

      {/* side_burner_base */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.side_burner_base.geometry}
        material={materials.side_burner_base}
        position={[0,0.001,0]}
        visible={sideBurner ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.side_burner_knob_logo.geometry}
          material={materials.side_burner_knob_logo}
        />
        <animated.group
          position={[0.734, 1.001, -0.197]}
          rotation={rotation_Side_burner}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes.side_burner_top.geometry}
            material={materials.side_burner_top}
            // position={[0.734, 1.001, -0.197]}
          />
        </animated.group>
      </mesh>

      {/* bottle_opener */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.bottle_opener.geometry}
        material={materials.bottle_opener}
        visible={bottleOpener ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bottle_opener_logo.geometry}
          material={materials.bottle_opener_logo}
        />
      </mesh>
      {/* umbrella_hole */}
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole.geometry}
        material={materials.umbrella_hole}
        visible={umbrellHole ? true : false}
      ></mesh> */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole_1.geometry}
        material={materials.umbrella_hole}
        visible={umbrellHole ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole_2.geometry}
        material={materials.black_part}
        visible={umbrellHole ? true : false}
      />

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.trash_drawer.geometry}
        material={materials.trash_drawer}
        visible={secondDoor === "Trash Drawer" ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.trash_drawer_handle.geometry}
        material={materials.trash_drawer_handle}
        visible={secondDoor === "Trash Drawer" ? true : false}
      />
      {refrigeratorType !== "None" ? (
        <>
          {/* Outdoor Rated Fridge */}
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_1.geometry}
            material={materials.outdoor_rated_fridge}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_2.geometry}
            material={materials.outdoor_rated_fridge_2}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_3.geometry}
            material={materials.outdoor_rated_fridge_frame}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_4.geometry}
            material={materials.outdoor_rated_fridge_handle}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_logo_frame001.geometry}
            material={materials.refrigerator_logo_frame}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_logo001.geometry}
            material={materials.refrigerator_logo}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes.siding_with_outdoor_rated_fridge.geometry}
        material={materials.siding}
        visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
      /> */}
          {/* Standard Fridge */}
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_1.geometry}
            material={materials.refrigerator}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_2.geometry}
            material={materials.refrigerator_frame}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_logo.geometry}
            material={materials.refrigerator_logo}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_logo_frame.geometry}
            material={materials.refrigerator_logo_frame}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.siding_with_standard_fridge.geometry}
            material={materials.siding}
            visible={grill === '38" Brahma' ? false : true}
          />

          <mesh
            castShadow
            receiveShadow
            geometry={nodes["brahma-siding_with_refrigerator"].geometry}
            material={materials.siding}
            visible={grill === '38" Brahma' ? true : false}
          />
        </>
      ) : (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.siding_without_refrigerator.geometry}
            material={materials.siding}
            visible={grill === '38" Brahma' ? false : true}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["brahma-siding_without_refrigerator"].geometry}
            material={materials.siding}
            visible={grill === '38" Brahma' ? true : false}
          />
        </>
      )}

      {/* 38"_double_door */}
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes['38"_double_door'].geometry}
        material={materials['38"_double_door']}
        visible={door === '38" Double Door' ? true : false}
      /> */}
      <group
        scale={[0.937, 1, 1]}
        visible={door === '38" Double Door' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_double_door_1'].geometry}
          material={materials['38"_double_door']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_double_door_2'].geometry}
          material={materials["Material.002"]}
        />
      </group>

      {/* '15"_sink */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['15"_sink'].geometry}
        material={materials['15"_sink']}
        visible={sink ? true : false}
      />

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.frame.geometry}
        material={materials.net_frame}
      />
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes.frame_with_brahma.geometry}
        material={materials.frame}
      /> */}

      {grill === '38" Brahma' ? (
        <>
          {tileColorScheme === "No Tile" && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_side.geometry}
                material={materials.metal_side}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["brahama-metal_top_with_sink"].geometry}
                material={materials.island_top}
                visible={sink ? true : false}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["brahama-metal_top_without_sink"].geometry}
                material={materials.island_top}
                visible={sink ? false : true}
              />
            </>
          )}
          {!(tileColorScheme === "No Tile") && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_top_with_brahma.geometry}
                material={materials.island_top}
                visible={sink ? false : true}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["brahma-island_top_with_sink"].geometry}
                material={materials.island_top}
                visible={sink ? true : false}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_frame_with_brahma.geometry}
                material={materials.frame}
                visible={sink ? false : true}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_frame_with_brahma_with_sink.geometry}
                material={materials.frame}
                visible={sink ? true : false}
              />
            </>
          )}
        </>
      ) : (
        <>
          {tileColorScheme === "No Tile" && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_side_island_top.geometry}
                material={materials.metal_side}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_top_with_sink.geometry}
                material={materials.island_top}
                visible={sink ? true : false}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_top.geometry}
                material={materials.island_top}
                visible={sink ? false : true}
              />
            </>
          )}
          {!(tileColorScheme === "No Tile") && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.frame_with_sink.geometry}
                material={materials.frame}
                visible={sink ? true : false}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_top_frame.geometry}
                material={materials.frame}
                visible={sink ? false : true}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_top.geometry}
                material={materials.island_top}
                visible={sink ? false : true}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_top_with_sink.geometry}
                material={materials.island_top}
                visible={sink ? true : false}
              />
            </>
          )}
        </>
      )}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.net.geometry}
        material={materials.net}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.plug.geometry}
        material={materials.plug}
      />

      {/* 30" Double Door */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.double_drawer.geometry}
        material={materials.double_drawer}
        visible={secondDoor === "Double Drawer" ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.double_drawer_handle.geometry}
          material={materials.double_drawer_handle}
        />
      </mesh>
      {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes.siding_with_door_drawer.geometry}
          material={materials.siding}
        /> */}
      {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes.siding_with_vertical_access_door.geometry}
          material={materials.siding}
        /> */}
      {/* Vertical Access Door */}
      {/* {sink ? ( // sink controling vertical access logic removed on clients request 08/04/2025
        <> */}
          {secondDoor === "Vertical Access Door" ? (
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.vertical_access_door.geometry}
              material={materials.vertical_access_door}
              visible={secondDoor === "Vertical Access Door" ? true : false}
            >
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.vertical_access_door_handle.geometry}
                material={materials.vertical_access_door_handle}
              />
            </mesh>
          ) : null}
        {/* </>
      ) : null} */}

      {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes.siding_2.geometry}
          material={materials.siding}
        /> */}

      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes['38"_doordrawer_1'].geometry}
        material={materials['38"_door/drawer']}
        visible={door === '38" Door/Drawer Combo' ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['38"_doordrawer_2'].geometry}
        material={materials['38"_door/drawer_2']}
        visible={door === '38" Door/Drawer Combo' ? true : false}
      /> */}
      <group
        visible={door === '38" Door/Drawer Combo' ? true : false}
        position={[0.037, 0, 0]}
        scale={[0.935, 1, 1]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_doordrawer_1'].geometry}
          material={materials['38"_door/drawer']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_doordrawer_2'].geometry}
          material={materials['38"_door/drawer_2']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_doordrawer_3'].geometry}
          material={materials["Material.001"]}
        />
      </group>

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.skirting.geometry}
        // material={materials.skirting}
        material={materials.siding}
      />
    </group>
  );
}
